import React from "react";

function Postings() {
  return (
    <div className="text-center mt-5">
      <p className="fs-3">Current Openings</p>
      <h1>
        Recent <strong>Job Postings</strong>
      </h1>

      <div
        style={{
          backgroundImage: "url('media/images/Jobposting.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          padding: "60px 0",
          marginTop: "40px",
          color: "white",
        }}
      >
        <div className="container">
          <div className="row text-center">
            {[
              { number: "100000", label: "+ Jobs Listed" },
              { number: "40000", label: "+ Members Served" },
              { number: "200000", label: "+ Resumes Scanned" },
              { number: "500", label: "+ Clients" },
            ].map((item, index) => (
              <div className="col-12 col-sm-6 col-lg-3 mb-4" key={index}>
                <h2>{item.number}</h2>
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Postings;
